function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

import React from 'react';
import { StyledIcon } from '../StyledIcon';
export var Linkedin = function Linkedin(props) {
  return React.createElement(StyledIcon, _extends({
    viewBox: "0 0 40 40",
    a11yTitle: "Linkedin"
  }, props), React.createElement("path", {
    d: "m13.34 30.6h-5v-16.11h5zm-2.51-18.3c-1.6 0-2.9-1.32-2.9-2.92s1.3-2.9 2.9-2.9 2.9 1.3 2.9 2.9-1.3 2.92-2.9 2.92zm21.23 18.3h-4.99v-7.84c0-1.87-.04-4.27-2.6-4.27-2.6 0-3 2.03-3 4.13v7.98h-5v-16.11h4.8v2.2h.07c.67-1.27 2.3-2.6 4.73-2.6 5.06 0 5.99 3.33 5.99 7.66z"
  }));
};